import React from 'react';
import PropTypes from 'prop-types';
import { Button, Text, Grid, Row, Column } from '../..';
import styled, { css } from 'styled-components';
import { withTheme } from '../../core/ThemeProvider';

const ImageContainer = withTheme(styled.div`
  ${({ mobileImage, desktopImage, coreTheme }) => css`
    display: flex;
    background-position: center center;
    background-size: cover;

    background-image: url(${desktopImage});
    height: 480px;
    align-items: center;

    @media (max-width: ${coreTheme.brk_xs}) {
      align-items: flex-start;
      justify-content: center;
      background-image: url(${mobileImage});
      height: 550px;
    }
  `}
`);

const Wrapper = withTheme(styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;

  ${({ coreTheme, position }) => css`
    @media (max-width: ${coreTheme.brk_xs}) {
      text-align: center;
      align-items: center;
    }

    text-align: ${position === 'center' ? 'center' : 'unset'};
    align-items: ${position === 'center' ? 'center' : 'flex-start'};
  `}
`);

const CarouselContent = ({
  desktopImage,
  mobileImage,
  title,
  body,
  buttonText,
  onClick,
  position,
  titleTag,
  inverse
}) => {
  return (
    <ImageContainer
      position={position}
      desktopImage={desktopImage}
      mobileImage={mobileImage}
    >
      <Grid>
        <Row
          reverse={position === 'right'}
          center={position === 'center' ? 'xs' : ''}
        >
          <Column xs={12} md={6} lg={6} xl={6}>
            <Wrapper position={position}>
              {title ? (
                <Text
                  type="bannerTitle"
                  tag={titleTag}
                  color={inverse ? 'white' : 'inherit'}
                >
                  {title}
                </Text>
              ) : null}
              {body ? (
                <Text type="body" color={inverse ? 'white' : 'inherit'}>
                  {body}
                </Text>
              ) : null}
              {buttonText ? (
                <Button text={buttonText} onClick={onClick} />
              ) : null}
            </Wrapper>
          </Column>
        </Row>
      </Grid>
    </ImageContainer>
  );
};

CarouselContent.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * Carousel content body content text
   */
  body: PropTypes.string,
  /**
   * Carousel content button text
   */
  buttonText: PropTypes.string,
  /**
   * Background image for carousel on desktop viewport
   */
  desktopImage: PropTypes.string.isRequired,
  /**
   * Carousel content inverse color. default to false
   */
  inverse: PropTypes.bool,
  /**
   * Background image for carousel on mobile viewport
   */
  mobileImage: PropTypes.string,
  /**
   * Carousel content onClick even callback handler
   */
  onClick: PropTypes.func,
  /**
   * Carousel content position, default to left
   */
  position: PropTypes.oneOf(['center', 'left', 'right']),
  /**
   * Carousel content header title
   */
  title: PropTypes.string,
  /**
   * Carousel content position title tag, default to h2
   */
  titleTag: PropTypes.string
};

CarouselContent.displayName = 'CarouselContent';

CarouselContent.defaultProps = {
  titleTag: 'h2',
  position: 'left',
  inverse: false,
  body: '',
  buttonText: '',
  mobileImage: '',
  onClick: null,
  title: ''
};

export default CarouselContent;
